import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ReadsTab } from '@/features/shipment-detail/reads/reads-tab';

// S05 · Reads (07 §3). `?read=<id>` selects a read, `?view=` the viewer's tab.
export const Route = createFileRoute('/_app/shipments/$id/reads')({
  validateSearch: z.object({
    read: z.string().optional(),
    view: z.enum(['shot', 'json', 'text', 'steps', 'check']).optional(),
  }),
  component: ReadsTab,
});
